import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '@aid/core/services';

declare const Beacon: any;

@Component({
  selector: 'aid-helpscout-dialog',
  template: `
    <div class="helpscout">
      <button [autofocus]="false" mat-icon-button (click)="onClose()">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  `,
  styleUrls: ['./helpscout-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HelpscoutDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<HelpscoutDialogComponent>,
    private userService: UserService
  ) {}

  ngOnInit() {
    const currentUser = this.userService.requireUser();

    Beacon('identify', {
      name: currentUser.name,
      email: currentUser.email
    });

    Beacon('toggle');
  }

  onClose() {
    Beacon('close');
    this.dialogRef.close();
  }
}
